import styled from 'styled-components';
import _ from 'lodash';
const getFontSize = (size, theme) => {
  let themeSize = _.get(theme, size);
  if (themeSize && (themeSize.size || themeSize.height)) {
    return [themeSize.size, themeSize.height];
  }
  if (size.size || size.height) {
    return [size.size, size.height];
  }
  return [size];
};
const generateHeaderCss = props => {
  const {
    theme
  } = props ?? {};
  if (!theme) return ``;
  let {
    global: {
      colors
    } = {},
    graniteTable
  } = theme;
  const {
    header
  } = graniteTable;
  let [fontSize, lineHeight] = getFontSize(header.fontSize, theme);
  return `
    background: ${colors[header.background] ?? header.background ?? colors['secondary']};
    color: ${header.color.dark && theme.dark ? header.color.dark : header.color.light && !theme.dark ? header.color.light : colors[header.color] ?? header.color};
    font-weight: ${header.fontWeight};
    font-size: ${fontSize};
    line-height: ${lineHeight};
    padding: ${header.padding};
    margin: ${header.margin};
    padding-top: ${header.paddingTop};
    padding-bottom: ${header.paddingBottom};
    padding-left: ${header.paddingLeft};
    padding-right: ${header.paddingRight};

  `;
};
const generateRowCss = props => {
  const {
    theme
  } = props ?? {};
  if (!theme) return ``;
  let {
    global: {
      colors
    } = {},
    graniteTable
  } = theme;
  const {
    row
  } = graniteTable;
  let [fontSize, lineHeight] = getFontSize(row.fontSize, theme);
  return `
    background: ${colors[row.background] ?? row.background ?? colors['secondary']};
    color: ${row.color.dark && theme.dark ? row.color.dark : row.color.light && !theme.dark ? row.color.light : colors[row.color] ?? row.color};
    font-weight: ${row.fontWeight};
    font-size: ${fontSize};
    line-height: ${lineHeight};
    padding: ${row.padding};
    margin: ${row.margin};
    padding-top: ${row.paddingTop};
    padding-bottom: ${row.paddingBottom};
    padding-left: ${row.paddingLeft};
    padding-right: ${row.paddingRight};
    min-height: 30px;
    &.-selected {
      background: ${row.selectedBackground ? colors[row.selectedBackground] ?? row.selectedBackground : undefined}
    }
    &:hover {
      background: ${colors[row.hoverBackground] ?? row.hoverBackground ?? colors['hover']};
    }
  `;
};
const generateStrippedRowCss = props => {
  const {
    theme,
    showStrippedRows
  } = props ?? {};
  if (!theme || !showStrippedRows) return ``;
  let {
    global: {
      colors
    } = {},
    graniteTable
  } = theme;
  const {
    row
  } = graniteTable;
  return `
    border-bottom: ${colors[row.rowBorder] ?? row.rowBorder ?? null};
    &:nth-child(even) > *:first-child {
      background: ${colors[row.evenRowBackground] ?? row.evenRowBackground ?? '#f7f7f7'};
    }
  `;
};
const sortIconsCss = props => {
  const {
    theme
  } = props ?? {};
  if (!theme) return ``;
  let {
    global: {
      colors
    } = {},
    graniteTable
  } = theme;
  const {
    header
  } = graniteTable;
  return `
  .rt-sort-asc {
    margin: -4px 0;
    color: ${colors[header.sortAscColor] ?? header.sortAscColor ?? colors[header.sortColor] ?? header.sortColor ?? '#fff'};
  }

  .rt-sort-desc {
    margin: -4px 0;
    color: ${colors[header.sortDescColor] ?? header.sortDescColor ?? colors[header.sortColor] ?? header.sortColor ?? '#fff'};
  }

  .rt-sort-asc.inactive {
    color: ${colors[header.sortAscInactiveColor] ?? header.sortAscInactiveColor ?? colors[header.sortInactiveColor] ?? header.sortInactiveColor ?? '#64646464'};
  }

  .rt-sort-asc.active {
    color: ${colors[header.sortAscActiveColor] ?? header.sortAscActiveColor ?? colors[header.sortActiveColor] ?? header.sortActiveColor ?? '#fff'};
  }

  .rt-sort-desc.inactive {
    color:  ${colors[header.sortDescInactiveColor] ?? header.sortDescInactiveColor ?? colors[header.sortInactiveColor] ?? header.sortInactiveColor ?? '#64646464'};
  }
  .rt-sort-desc.active {
    color: ${colors[header.sortDescActiveColor] ?? header.sortDescActiveColor ?? colors[header.sortActiveColor] ?? header.sortActiveColor ?? '#fff'};
  }

  `;
};
const getExtendedStyles = props => {
  const {
    theme
  } = props ?? {};
  let {
    graniteTable
  } = theme;
  const {
    extend
  } = graniteTable;
  return extend;
};
const TableContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  ${({
  className,
  ...rest
}) => `
  &.${className} * {
    box-sizing: border-box;
  }

  &.${className} .rt-table {
    flex: auto 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    border-collapse: collapse;
    overflow: auto;
    border: 1px solid ${rest.theme?.graniteTable?.tableOuterBorderColor ?? rest.theme.global.colors['border']};
    //border: 1px solid red;
    // margin-bottom: 0.5rem;
    opacity: 0;
    animation: bodyAnimation 200ms 0s forwards ease-in;
  }
  @keyframes bodyAnimation {
    from {opacity: 0}
    to {opacity: 1;}
  }

  &.${className} .rt-thead {
    position: sticky;
    top: 0;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    ${generateHeaderCss(rest)};
  }

  &.${className} .rt-thead.-headerGroups {
    background: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  &.${className} .rt-thead.-filters {
    border-bottom: 1px solid white;
  }

  &.${className} .rt-thead.-filters input,
  &.${className} .rt-thead.-filters select {
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #fff;
    // padding: 5px 7px;
    font-size: inherit;
    border-radius: 3px;
    font-weight: normal;
    outline-width: 0;
  }

  &.${className} .rt-thead.-filters .rt-th {
    border-right: 1px solid rgba(0, 0, 0, 0.02);
  }

  &.${className} .rt-thead.-header {
    box-shadow: 0 2px 15px 0px rgba(0, 0, 0, 0.15);
  }

  &.${className} .rt-thead .rt-tr {
    // text-align: center;
  }

  &.${className} .rt-thead .rt-th,
  &.${className} .rt-thead .rt-td {
    // padding: 7px 5px;
    line-height: normal;
    position: relative;
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: inset 0 0 0 0 transparent;
  }
  &.${className} .rt-thead .rt-td {
    padding: 0 5px;
  }

  &.${className} .rt-thead .rt-th.-sort-asc,
  &.${className} .rt-thead .rt-td.-sort-asc {
    box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.6);
  }

  &.${className} .rt-thead .rt-th.-sort-desc,
  &.${className} .rt-thead .rt-td.-sort-desc {
    box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.6);
  }

  &.${className} .rt-thead .rt-th.-cursor-pointer,
  &.${className} .rt-thead .rt-td.-cursor-pointer {
    // cursor: pointer;
  }

  &.${className} .rt-thead .rt-th:last-child,
  &.${className} .rt-thead .rt-td:last-child {
    /* border-right: 0; */
  }

  &.${className} .rt-thead .rt-th:focus {
    outline-width: 0;
  }

  &.${className} .rt-thead .rt-resizable-header {
    // overflow: visible;
  }

  &.${className} .rt-thead .rt-resizable-header:last-child {
    overflow: hidden;
  }

  &.${className} .rt-thead .rt-th > div {
    padding: 7px 0px;
  }
  
  &.${className} .rt-thead .rt-resizable-header-content {
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  &.${className} .rt-thead .rt-header-pivot {
    border-right-color: #f7f7f7;
  }

  &.${className} .rt-thead .rt-header-pivot:after,
  &.${className} .rt-thead .rt-header-pivot:before {
    left: 100%;
    top: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &.${className} .rt-thead .rt-header-pivot:after {
    border-color: rgba(255, 255, 255, 0);
    border-left-color: #fff;
    border-width: 8px;
    margin-top: -8px;
  }

  &.${className} .rt-thead .rt-header-pivot:before {
    border-color: rgba(102, 102, 102, 0);
    border-left-color: #f7f7f7;
    border-width: 10px;
    margin-top: -10px;
  }

  &.${className} .rt-tbody {
    flex: 99999 1 auto;
    display: flex;
    flex-direction: column;
    // overflow: auto;
  }

  &.${className} .rt-tbody .rt-tr-group {
    border-bottom: solid 1px rgba(0, 0, 0, 0.05);
  }

  .rt-tbody .smooth-dnd-draggable-wrapper {
    ${generateStrippedRowCss(rest)};
  }

  &.${className} .rt-tbody .rt-tr {
    ${generateRowCss(rest)};
  }

  &.${className} .rt-tbody .rt-tr-group:last-child {
    border-bottom: 0;
  }

  &.${className} .rt-tbody .rt-td {
    border-right: 1px solid rgba(0, 0, 0, 0.02);
  }

  &.${className} .rt-tbody .rt-td:last-child {
    border-right: 0;
  }

  &.${className} .rt-tbody .rt-expandable {
    cursor: pointer;
    text-overflow: clip;
  }

  &.${className} .rt-tr-group {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  &.${className} .rt-tr {
    // flex: 1 0 auto;
    display: flex;
  }

  &.${className} .rt-th,
  &.${className} .rt-td {
    /* flex: 1 0 0px; */
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0px 5px;
    overflow: hidden;
    transition: 0.3s ease;
    transition-property: width, min-width, padding, opacity;
  }

  &.${className} .rt-th.-hidden,
  &.${className} .rt-td.-hidden {
    width: 0 !important;
    min-width: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    opacity: 0 !important;
  }

  &.${className} .rt-expander {
    display: inline-block;
    position: relative;
    margin: 0;
    color: transparent;
    margin: 0 10px;
  }

  &.${className} .rt-expander:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-90deg);
    border-left: 5.04px solid transparent;
    border-right: 5.04px solid transparent;
    border-top: 7px solid rgba(0, 0, 0, 0.8);
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    cursor: pointer;
  }

  &.${className} .rt-expander.-open:after {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  &.${className} .rt-resizer {
    display: inline-block;
    position: absolute;
    width: 10px;
    top: 0;
    bottom: 0;
    right: -5px;
    cursor: col-resize;
    z-index: 10;
  }

  &.${className} .rt-tfoot {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0px 15px 0px rgba(0, 0, 0, 0.15);
  }

  &.${className} .rt-tfoot .rt-td {
    border-right: 1px solid rgba(0, 0, 0, 0.05);
  }

  &.${className} .rt-tfoot .rt-td:last-child {
    /* border-right: 0; */
  }

  &.${className}.-striped .rt-tr.-odd {
    background: rgba(0, 0, 0, 0.03);
  }

  &.${className}.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &.${className} .-pagination {
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    padding: 3px;
    box-shadow: 0 0px 15px 0px rgba(0, 0, 0, 0.1);
    border-top: 2px solid rgba(0, 0, 0, 0.1);
  }

  &.${className} .-pagination input,
  &.${className} .-pagination select {
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #fff;
    padding: 5px 7px;
    font-size: inherit;
    border-radius: 3px;
    font-weight: normal;
    outline-width: 0;
  }

  &.${className} .-pagination .-btn {
    appearance: none;
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 3px;
    padding: 6px;
    font-size: 1em;
    color: rgba(0, 0, 0, 0.6);
    background: rgba(0, 0, 0, 0.1);
    transition: all 0.1s ease;
    cursor: pointer;
    outline-width: 0;
  }

  &.${className} .-pagination .-btn[disabled] {
    opacity: 0.5;
    cursor: default;
  }

  &.${className} .-pagination .-btn:not([disabled]):hover {
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
  }

  &.${className} .-pagination .-previous,
  &.${className} .-pagination .-next {
    flex: 1;
    text-align: center;
  }

  &.${className} .-pagination .-center {
    flex: 1.5;
    text-align: center;
    margin-bottom: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
  }

  &.${className} .-pagination .-pageInfo {
    display: inline-block;
    margin: 3px 10px;
    white-space: nowrap;
  }

  &.${className} .-pagination .-pageJump {
    display: inline-block;
  }

  &.${className} .-pagination .-pageJump input {
    width: 70px;
    text-align: center;
  }

  &.${className} .-pagination .-pageSizeOptions {
    margin: 3px 10px;
  }

  &.${className} .rt-noData {
    display: block;
    margin:0 auto;
    // background: rgba(255, 255, 255, 0.8);
    transition: all 0.3s ease;
    z-index: 1;
    pointer-events: none;
    padding: 5px;
    color: ${rest?.theme?.graniteTable?.noRecordTextColor ?? 'rgba(0, 0, 0, 0.5)'};
    font-size: 12px;
    line-height: 16px;
    align-self: center;
  }

  &.${className} .-loading {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    transition: all 0.3s ease;
    z-index: -1;
    opacity: 0;
    pointer-events: none;
  }

  &.${className} .-loading > div {
    position: absolute;
    display: block;
    text-align: center;
    width: 100%;
    top: 50%;
    left: 0;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.6);
    transform: translateY(-52%);
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  &.${className} .-loading.-active {
    opacity: 1;
    z-index: 2;
    pointer-events: all;
  }

  &.${className} .-loading.-active > div {
    transform: translateY(50%);
  }

  &.${className} .rt-resizing {
    transition: none !important;
    cursor: col-resize;
    user-select: none;

  }

  &.${className} .normalCursor {
    cursor: default;
  }

  &.${className} .rt-resizing > div.rt-resizable-header-content {
    pointer-events:none;
  }

  &.${className} .rt-right-align {
    text-align: right;
  }

  &.${className} .rt-sort {
    display: inline-flex;
    flex-direction: column;
  }

  &.${className} .rt-sort-asc,  &.${className} .rt-sort-desc {
    cursor: pointer;
  }

  ${sortIconsCss(rest)}

  &.${className} .rt-tbody .rt-hover-visible {
    visibility: hidden; 
  }
  &.${className} .rt-tbody .rt-tr:hover .rt-hover-visible,
  &.${className} .rt-tbody .rt-tr .rt-hover-visible:focus-within > div {
    visibility: visible;
  }
  &.${className} .selection-header  input ~ div {
    border-color:${rest?.theme?.graniteTable?.headerCheckboxBorderColor ?? 'white'};
    svg {
      stroke: white;
    }
  }
  &.${className} .rt-th.actions, .rt-td .actions-cell {
    min-width: fit-content !important;
  }
  &.${className} .rt-table {
    ${getExtendedStyles(rest)}
  }
  &.${className} .clickable-row {
    cursor: pointer;
  }
  &.${className} .clickable-row {
    cursor: pointer; 
  }
  .smooth-dnd-ghost.rt-resizable-header.rt-th  {
    border-right: none;
  }
`}
`;
export default TableContainer;